import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'fundAccounts';

export interface FormValues {
  fundAccounts: string[];
}

export const fundAccountValidation = yup
  .array()
  .of(yup.string())
  .nullable()
  .test('required', 'You need to select at least one account to proceed.', value => {
    return value !== null && value !== undefined && value.length > 0;
  });

export const validation = yup.object().shape({
  fundAccounts: fundAccountValidation,
});
